import OperatorService from "@/api/services/operator.service";
import AdminService from "@/api/services/admin.service";
import { keysLower } from "@/core/helpers";
import http from "@/api/services/http.service";

const ServersService = {
  getList(params = { search: "", page: 1, count: 10 }) {
    return OperatorService.get(`/dvr-servers`, { headers: params });
  },

  create(newCamera) {
    return OperatorService.post(`/dvr-servers`, newCamera);
  },

  get(id) {
    return OperatorService.get(`/dvr-servers/${id}`);
  },

  update(id, newCamera) {
    return OperatorService.put(`/dvr-servers/${id}`, newCamera);
  },

  updateIsNewAgent(id, is_new_agent) {
    return AdminService.put(`/dvr-servers/${id}/is-new-agent`, { is_new_agent });
  },

  delete(id) {
    return OperatorService.delete(`/dvr-servers/${id}`);
  },

  moveCameras(id_server_from, id_server_to, force) {
    return OperatorService.put(`/dvr-servers/move-cameras`, {
      id_server_from,
      id_server_to,
      force,
    });
  },

  moveCamerasReserve(id_server_from, id_server_to, force) {
    return OperatorService.put(`/dvr-servers/move-cameras/reserve`, {
      id_server_from,
      id_server_to,
      force,
    });
  },

  getRecommend(id_server) {
    return OperatorService.get(`/dvr-servers/recommend`, { headers: { id_server } });
  },

  getRecommendPaginate(params = { id_server: "", page: 1, search: "", count: 50, is_for_rrtsp: 0 }) {
    return OperatorService.get(`/dvr-servers/recommend/paginate`, { headers: params });
  },

  getDvrRecommendByMediaCore(id_media_core, id_proxy_server) {
    return OperatorService.get(`/dvr-servers/recommend-by-media-core`, {
      headers: { id_media_core, id_proxy_server },
    });
  },

  getProxyRecommendByMediaCore(id_media_core, id_server) {
    return OperatorService.get(`/proxy-servers/recommend-by-media-core`, {
      headers: { id_media_core, id_server },
    });
  },

  getRecommendReserve(id, destination_cluster_alias) {
    return OperatorService.get(`/dvr-servers/recommend/${id}/reserve`, { headers: { destination_cluster_alias } });
  },

  getModes() {
    return http.get(`/dvr-server-modes`).then((resp) => keysLower(resp.data));
  },

  getServerGroups() {
    return OperatorService.get(`/dvr-servers-groups`);
  },

  getServerReserveTransfersList(id, headers) {
    return OperatorService.get(`/dvr-servers/${id}/reserve-transfers`, { headers });
  },

  returnCameras(id, force) {
    return AdminService.put(`/reserve-transfers/${id}/return-cameras`, {
      force,
    });
  },
};

export default ServersService;
